import * as actions from '../dispatcherActions';
import moment from 'moment';
import { contains } from '../../../ts-helpers/contains';

const initialFilterSettings = {
  date: moment().format('YYYY-MM-DD'),
  status: [],
  payer: '',
  driver: '',
  route: '',
  shift: '',
  search: '',
  startTime: null,
  endTime: null,
  grouped: true,
};

const initialState = {
  legs: [],
  legsMileage: 0,
  legsCostCalculated: 0,
  legsCostFromPayer: 0,
  filterSettings: initialFilterSettings,
  checkedLegs: [],
  selectedLeg: null,
  loadingLegs: false,
  hardLoadingLegs: false,
  page: 0,
  legs_count: 0,
  data_count: 0,
};

const deepCopyState = (state) => {
  state = JSON.parse(JSON.stringify(state));
  if (state && state.filterSettings && state.filterSettings.date) {
    state.filterSettings.date = moment(state.filterSettings.date).format('YYYY-MM-DD');
  }

  return state;
};

const getRandomInt = (min: number, max: number): number => {
  return Math.floor(Math.random() * (max - min + 1)) + min;
};

const generateUniqueId = (): string => {
  return `id-${Date.now()}-${getRandomInt(1000, 1000000000)}`;
};

const setLegOrTripKeyAndRemoveHighlight = (type: string, element: any) => {
  element.uniqueKey = `key-${type}-${element.id}-${generateUniqueId()}`;
  element.highlighted = false;
};

const finalizeStateDate = (state) => {
  if (state.filterSettings.grouped) {
    state.legs.forEach((trip: any, i: number) => {
      state.legs[i].legs.forEach((leg: any, j: number) => {
        setLegOrTripKeyAndRemoveHighlight('leg', state.legs[i].legs[j]);
      });

      setLegOrTripKeyAndRemoveHighlight('trip', state.legs[i]);
    });
  } else {
    state.legs.map((leg: any, i: number) => {
      setLegOrTripKeyAndRemoveHighlight('leg', state.legs[i]);
    });
  }

  state = Object.assign({}, { ...state }, { ...state });
  return state;
};

const setLoading = (state, payload) => {
  state = Object.assign({}, state, {
    loadingLegs: payload,
  });

  return state;
};

const setHardLoading = (state, payload) => {
  state = Object.assign({}, state, {
    hardLoadingLegs: payload,
  });

  return state;
};

const updateLegs = (state, payload) => {
  state = Object.assign({}, state, {
    legs: payload.legs,
    legs_count: payload.legs_count,
    data_count: payload.data_count,
    legsMileage: payload.legs_mileage,
    legsCostCalculated: payload.legs_cost_calculated,
    legsCostFromPayer: payload.legs_cost_from_payer,
  });

  return finalizeStateDate(state);
};

const updateOneLeg = (state, payload) => {
  const dbLeg = payload.leg;
  state = deepCopyState(state);

  if (state.filterSettings.grouped) {
    state.legs.forEach((trip, i) => {
      if (trip.id == dbLeg.trip_id) {
        state.legs[i].legs.forEach((leg, j) => {
          if (leg.id == dbLeg.id) {
            state.legs[i].legs[j] = dbLeg;

            return false;
          }
        });

        return false;
      }
    });
  } else {
    state.legs.forEach((leg, j) => {
      if (leg.id == dbLeg.id) {
        state.legs[j] = dbLeg;
        return false;
      }
    });
  }

  state = Object.assign({}, { ...state }, { ...state });
  return finalizeStateDate(state);
};

const updateManyLeg = (state, payload) => {
  const dbLegs = payload.data.legs;
  state = deepCopyState(state);

  if (state.filterSettings.grouped) {
    dbLegs.forEach((dbLeg) => {
      state.legs.forEach((trip, i) => {
        if (trip.id == dbLeg.trip_id) {
          state.legs[i].legs.forEach((leg, j) => {
            if (leg.id == dbLeg.id) {
              state.legs[i].legs[j] = dbLeg;
              return false;
            }
          });

          return false;
        }
      });
    });
  } else {
    dbLegs.forEach((dbLeg) => {
      state.legs.forEach((leg, j) => {
        if (leg.id == dbLeg.id) {
          state.legs[j] = dbLeg;
          return false;
        }
      });
    });
  }

  state = Object.assign({}, { ...state }, { ...state });
  state = finalizeStateDate(state);

  const legIds = dbLegs.map((leg: any) => leg.id);

  if (payload.Highlight) {
    state.legs.forEach((trip, i) => {
      state.legs[i].legs.forEach((leg, j) => {
        if (contains(legIds, leg.id)) {
          state.legs[i].legs[j].highlighted = true;
        }
      });
    });
  } else {
    state.legs.forEach((leg, j) => {
      if (contains(legIds, leg.id)) {
        state.legs[j].highlighted = true;
      }
    });
  }

  return state;
};

const unHighlightApiUpdatedLegs = (state) => {
  state = Object.assign({}, { ...state }, { ...state });
  return finalizeStateDate(state);
};

const updateLegsOnly = (state, payload) => {
  state = Object.assign({}, state, {
    legs: payload,
  });

  return finalizeStateDate(state);
};

const changeFilter = (state, payload) => {
  state = Object.assign({}, state, {
    filterSettings: payload,
    legs: [],
  });

  return finalizeStateDate(state);
};

const selectLeg = (state, payload) => {
  state = Object.assign({}, state, {
    selectedLeg: payload,
  });

  return finalizeStateDate(state);
};

const changeCheckedLegs = (state, payload) => {
  state = Object.assign({}, state, {
    checkedLegs: payload,
  });

  return finalizeStateDate(state);
};

const setPage = (state, payload) => {
  state = Object.assign({}, state, {
    page: payload,
  });

  return finalizeStateDate(state);
};

export default (state = initialState, { type, payload = null }) => {
  switch (type) {
    case actions.SET_LOADING:
      return setLoading(state, payload);
    case actions.SET_HARD_LOADING:
      return setHardLoading(state, payload);
    case actions.UPDATE_LEGS:
      return updateLegs(state, payload);
    case actions.UPDATE_ONE_LEG:
      return updateOneLeg(state, payload);
    case actions.UPDATE_MANY_LEG:
      return updateManyLeg(state, payload);
    case actions.UNHIGHLIGHT_LEG_API_UPDATED:
      return unHighlightApiUpdatedLegs(state);
    case actions.UPDATE_LEGS_ONLY:
      return updateLegsOnly(state, payload);
    case actions.CHANGE_FILTER:
      return changeFilter(state, payload);
    case actions.CHANGE_CHECKED_LEGS:
      return changeCheckedLegs(state, payload);
    case actions.SELECT_LEG:
      return selectLeg(state, payload);
    case actions.SET_PAGE:
      return setPage(state, payload);
  }
  return state;
};
